var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.361572 0.859818L7.92407 20.7973L18.9241 7.04732L15.2803 3.47232L0.361572 0.859818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64282 8.42232L7.92407 20.7973L18.9241 7.04732L9.64282 8.42232Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.361572 0.859818L9.64282 8.42232L15.2803 3.47232L0.361572 0.859818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64278 8.76607C9.47778 8.76607 9.32653 8.64232 9.3059 8.47045C9.2784 8.28482 9.40903 8.10607 9.59465 8.07857L18.8759 6.70357C19.0615 6.67607 19.2403 6.8067 19.2678 6.99232C19.2953 7.17795 19.1647 7.3567 18.979 7.3842L9.69778 8.7592C9.67715 8.76607 9.65653 8.76607 9.64278 8.76607Z",
    fill: "#FF5252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6428 8.76607C9.56717 8.76607 9.49155 8.73857 9.4228 8.69044L0.141546 1.12794C-0.00282916 1.00419 -0.0234543 0.791069 0.0934207 0.639819C0.210296 0.495444 0.430296 0.467944 0.574671 0.591694L9.85592 8.15419C10.0003 8.27107 10.0278 8.49107 9.90404 8.63544C9.84217 8.72482 9.74592 8.76607 9.6428 8.76607Z",
    fill: "#FF5252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92402 21.1411C7.91027 21.1411 7.88964 21.1411 7.87589 21.1411C7.69027 21.1136 7.55964 20.9417 7.58027 20.7561L9.29902 8.38107C9.31277 8.29857 9.35402 8.22294 9.41589 8.16794L15.0534 3.21794C15.1978 3.09419 15.4109 3.10794 15.5415 3.25232C15.6653 3.39669 15.6515 3.60982 15.5071 3.74044L9.96589 8.60794L8.26777 20.8454C8.24027 21.0173 8.09589 21.1411 7.92402 21.1411Z",
    fill: "#FF5252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92409 21.1411C7.90347 21.1411 7.88972 21.1411 7.86909 21.1342C7.74534 21.1136 7.64222 21.0311 7.60097 20.9142L0.0384651 0.976692C-0.00278488 0.866692 0.0178401 0.736067 0.0934651 0.639817C0.16909 0.543567 0.299715 0.502317 0.41659 0.522942L15.3353 3.13544C15.4041 3.14919 15.466 3.17669 15.5141 3.23169L19.1578 6.80669C19.2816 6.93044 19.2953 7.12982 19.1853 7.26732L8.18534 21.0173C8.12347 21.0929 8.02722 21.1411 7.92409 21.1411ZM0.89784 1.29982L8.03409 20.1098L18.4635 7.07482L15.1153 3.79544L0.89784 1.29982Z",
    fill: "#FF5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrc20);
export default __webpack_public_path__ + "static/media/trc20.fa7bf0267f01a47fad3400c0c79fd436.svg";
export { ForwardRef as ReactComponent };